$.ajax( {
  url: 'https://reallyfreegeoip.org/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    $('body').addClass(location.country_code);
    $('body').attr('data-country',location.country_code);
    localStorage.setItem('Country', location.country_code);
    
    if(location.country_code == 'AU'){
    	var shippingCheck = $('.AU-shipping').data('free');
      	if(shippingCheck){
      		$('.free_shipping').removeClass('hide');
        }else{
        	$('.AU-shipping').removeClass('hide');
        }
    }else if(location.country_code == 'NZ'){
    	var shippingCheck = $('.NZ-shipping').data('free');
      	if(shippingCheck){
      		$('.free_shipping').removeClass('hide');
        }else{
        	$('.NZ-shipping').removeClass('hide');
        }
    }else if(location.country_code == 'US'){
    	var shippingCheck = $('.US-shipping').data('free');
      	if(shippingCheck){
      		$('.free_shipping').removeClass('hide');
        }else{
        	$('.US-shipping').removeClass('hide');
        }
    }
    
    if (["US", "NZ","AU"].indexOf(location.country_code) != -1){
      $('.shipping-savings-message').removeClass('hide');
    }
    
  }
});
